// The public GA4 web-stream identifier, verified in the mdc life account.
const MEASUREMENT_ID = 'G-FCFYY03P4D'
const cleanUrl = value => {
  try { const url=new URL(value); return ['http:','https:'].includes(url.protocol) ? url.origin+url.pathname : '' } catch { return '' }
}
function createAnalytics() {
  let previous = null
  let initialized = false
  return function pageView(win, location, title) {
    if (win.location.hostname !== 'mdc.life' || win.location.protocol !== 'https:') return false
    const url=cleanUrl(location.href || `https://mdc.life${location.pathname}`)
    if (!url || url===previous) return false
    win.dataLayer=win.dataLayer || []
    win.gtag=win.gtag || function(){ win.dataLayer.push(arguments) }
    if(!initialized) {
      win.gtag('js',new Date())
      win.gtag('config',MEASUREMENT_ID,{
        send_page_view:false,
        allow_google_signals:false,
        allow_ad_personalization_signals:false,
        page_location:url,
        page_referrer:cleanUrl(win.document.referrer),
      })
      const script=win.document.createElement('script')
      script.async=true
      script.src=`https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
      win.document.head.appendChild(script)
      initialized=true
    }
    win.gtag('event','page_view',{
      send_to:MEASUREMENT_ID,
      page_location:url,
      page_referrer:previous || cleanUrl(win.document.referrer),
      page_title:title,
    })
    previous=url
    return true
  }
}
function trackRelatedReadingClick(win, sourceId, destinationId, position) {
  if (win?.location?.hostname !== 'mdc.life' || win.location.protocol !== 'https:' || typeof win.gtag !== 'function') return false
  const validId = value => typeof value === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
  if (!validId(sourceId) || !validId(destinationId) || sourceId === destinationId || !Number.isInteger(position) || position < 1 || position > 3) return false
  try {
    win.gtag('event', 'related_reading_click', {
      send_to: MEASUREMENT_ID,
      source_article: sourceId,
      destination_article: destinationId,
      link_position: position,
      page_location: cleanUrl(win.location.href),
      page_referrer: cleanUrl(win.document.referrer),
    })
    return true
  } catch { return false } // Analytics must never prevent navigation.
}
module.exports={MEASUREMENT_ID,cleanUrl,createAnalytics,trackRelatedReadingClick}
